import { Card, Col, Divider, Row, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ButtonAction from 'components/Common/ButtonAction';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import SkeletonPage from 'components/Common/SkeletonPage';
import Error403 from 'components/Error/Error403';
import CellTable from 'components/Common/CellTable';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useWBSRepo from '../../services/repo/useWBSRepo';
import { useNavigate } from 'react-router-dom';
import { sorterTable } from 'utils/Helper';

export default function TaskList() {
  useTopbarTitleHooks("Task List");
  const navigate = useNavigate();
  const WBSRepo = useWBSRepo();

  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false);
  const isLoadingPrivilege = useRef(true);
  const hasPrivilegePage = useRef(true);

  const [filters, setFilters] = useState({
    wbsNo: ""
  })

  const [tableParams, setTableParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: { ...filters },
    orderBy: "wbsNo",
    isAscending: true,
  });

  const fetchData = async () => {
    const payload = {
      ...tableParams
    }
    const res = await WBSRepo.getWBSTaskList(payload)

    if (res?.detail == 'OK' && res?.status === 200) {

      setData(res?.data?.content)
      setTotalData(res?.data?.totalElements)
    }
  };


  const handleSelect = (record) => {
    const taskId = record.taskId;
    const wfData = record.wfData;

    if (wfData && wfData.includes("form_url::")) {
      const routePath = wfData.split("form_url::")[1]; // ex: 'wbs/task-approval'
      navigate(`${APP_ROUTE_PREFIX}/${routePath}/${taskId}`);
    } else {
      console.warn("Invalid wfData format", wfData);
    }
  };


  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams(prevParams => ({
      ...prevParams,
      pageNumber: pagination?.current,
      pageSize: pagination?.pageSize,
      orderBy: sorter?.field || prevParams?.orderBy,
      isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
    }));
    if (pagination.pageSize !== tableParams?.pageSize) {
      setData([]);
    }
  };

  // const handleTableChange = (pagination, filters, sorter) => {
  //   setTableParams(prev => ({
  //     ...prev,
  //     pageNumber: pagination.current - 1,
  //     pageSize: pagination.pageSize,
  //     orderBy: sorter?.field || prev.orderBy,
  //     isAscending: sorterTable(sorter?.order, prev.isAscending)
  //   }));
  //   if (pagination.pageSize !== tableParams.pageSize) setData([]);
  // };

  const fetchCheckPrivilege = async () => {

    isLoadingPrivilege.current = false;
    hasPrivilegePage.current = true;
    setIsLoadedPrivilege(true);
    fetchData();
  };

  useEffect(() => {
    fetchCheckPrivilege();
  }, []);

  useEffect(() => {
    if (isLoadedPrivilege) fetchData();
  }, [JSON.stringify(tableParams)]);

  const columns = [
    {
      title: "Action",
      key: "action",
      width: "80px",
      render: (_, record) => (
        <ButtonAction
          buttons={["select"]}
          onSelect={() => handleSelect(record)}
          data={record}
          txtBtnSelect="Update"
          tooltipSelect="Update this task"
        />
      )
    },
    {
      title: "No WBS Form",
      dataIndex: "wbsNo",
      sorter: true,
      render: (text) => <CellTable data={text} />
    },
    {
      title: "Status",
      dataIndex: "wfValue",
      // sorter: true,
      render: (text) => <CellTable data={text} />
    },
    {
      title: "PIC",
      dataIndex: "submissionUserFullName",
      // sorter: true,
      render: (text) => <CellTable data={text} />
    },
    {
      title: "Approver",
      dataIndex: "approverUserFullName",
      // sorter: true,
      render: (text) => <CellTable data={text} />
    },
    {
      title: "Created Date",
      // sorter: true,
      render: (_, record) => <CellTable data={record.createdDate} />
    },
    {
      title: "Last Update",
      // sorter: true,
      render: (_, record) => <CellTable data={record.updatedDate} />
    }

  ];

  return (
    <>
      {hasPrivilegePage.current ? (
        <Space direction="vertical" size="large" className="space-vertical-flex">
          <Card size="big" bordered={false}>
            {isLoadingPrivilege.current ? (
              <SkeletonPage />
            ) : (
              <>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <h3 style={{ fontWeight: 600, marginBottom: 16 }}>Task List</h3>
                  </Col>
                </Row>
                <CustomAntdTable
                  columns={columns}
                  dataSource={data}
                  rowKey={"taskId"}
                  tableParam={tableParams}
                  totalData={totalData}
                  loading={isLoadingList}
                  onChange={handleTableChange}
                />
              </>
            )}
          </Card>
        </Space>
      ) : (
        <Error403 />
      )}
    </>
  );
}
